<template>
    <div class="modal-invoice">
        <SOSlotModal :modal-title="modalTitle" :modal-id="modalId" @close="back">
            <template v-slot:modal-body>
                <div>
                    <div class="m-d-20">
                        <SOInformation myStyle="margin: 0px -40px;">
                            <template v-slot:subtitle>
                                <p class="m-d-0">
                                    Menghapus transaksi akan mengubah pencatatan pendapatan, hutang, atau piutang pada
                                    akun terkait di laporan keuangan Anda.
                                </p>
                            </template>
                        </SOInformation>
                    </div>
                    <div class="m-d-20" v-if="isLunas">
                        <RefundInput
                            pembayaran="Tunai"
                            :nominal="nominal"
                            :selected="posted.akunKeuangan"
                            @onSelect="onSelectKas"
                        />
                    </div>
                    <div class="m-d-16">
                        <SOInputRegular
                            id="input-alasan"
                            title="Catatan (Opsional)"
                            placeholder="Catatan...."
                            :value="posted.catatan"
                            autocomplete="off"
                            @input="onChangeInput"
                        />
                    </div>
                </div>
            </template>
            <template v-slot:modal-footer>
                <div class="">
                    <SOButton
                        :outline-danger="true"
                        :full="true"
                        :text="'Setujui Pembatalan'"
                        :id="`setujui-tolak`"
                        :disable="isFetching"
                        :loading="isFetching"
                        @action="doConfirm"
                    />
                </div>
            </template>
        </SOSlotModal>
    </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";

import SOInformation from "@/so-components/global/ui/SOInformation.vue";
import SOSlotModal from "@/so-components/global/slot/SOSlotModal.vue";
import SOInputRegular from "@/so-components/global/input/SOInputRegular.vue";
import SOButton from "@/so-components/global/ui/SOButton";

import { moduleName } from "../../store/state";
import RefundInput from "../RefundInput.vue";

export default {
    name: "TerimaPermintaan",
    components: {
        SOSlotModal,
        SOButton,
        SOInputRegular,
        SOInformation,
        RefundInput,
    },
    data() {
        return {
            modalId: "confirm-add-invoice",
            modalTitle: "Konfirmasi Selesaikan Transaksi",
            page: {
                loading: false,
            },
            posted: {
                catatan: "",
                akunKeuangan: "",
            },
            isNotification: false,
        };
    },
    beforeRouteLeave(to, from, next) {
        this.closeModal();
        next();
    },
    mounted() {
        this.isNotification = this.$route.params.isNotification
        $(`#${this.modalId}`).modal("show");
    },
    computed: {
        ...mapGetters(moduleName, {
            isCheckAll: "isCheckAll",
            selectedTransaksi: "selectedTransaksi",
        }),
        isFetching() {
            return this.page.loading;
        },
        isLunas() {
            return this.$route.query.isLunas;
        },
        idKaryawan() {
            return this.$route.query.idKaryawan;
        },
        nominal() {
            return this.$route.query.nominal;
        },
        getInvoiceId() {
            return this.$route.params.invoiceId;
        },
    },
    methods: {
        ...mapActions({
            cancelInvoice: `${moduleName}/cancelInvoice`,
            cancelInvoiceLunas: `${moduleName}/cancelInvoiceLunas`,
        }),
        async back(idx = -1) {
            await this.$router.go(idx);
        },
        closeModal() {
            $(`#${this.modalId}`).modal("hide");
        },
        onChangeInput(val) {
            this.posted.catatan = val;
        },
        onSelectKas(val) {
            this.posted.akunKeuangan = val;
        },
        setFetching(val) {
            this.page.loading = val;
        },
        refundDana() {
            if (this.isFetching) {
                return;
            }
            let {
                posted: { catatan, akunKeuangan },
                getInvoiceId,
                idKaryawan,
            } = this;
            this.setFetching(true);
            this.cancelInvoiceLunas({
                id_invoice: getInvoiceId,
                id_akun: akunKeuangan,
                id_karyawan: idKaryawan,
                alasan_batal: catatan,
            })
                .then((res) => {
                    if (!res.data) {
                        this.$toast.error(res);
                    } else {
                        let { code, data, status, msg } = res.data;
                        if (code === 200 && status) {
                            this.$toast.success(msg);
                            this.setFetching(false);
                            if (this.isNotification) {
                  this.flutterNavigate("dashboard/notification");
                  return;
                            }
                            this.$router.go(-2);
                        } else {
                            this.$toast.error(msg);
                            this.setFetching(false);
                        }
                    }
                })
                .catch((e) => {
                    this.$toast.error(e);
                    this.setFetching(false);
                });
        },
        pembatalan() {
            if (this.isFetching) {
                return;
            }
            let {
                posted: { catatan },
                getInvoiceId,
            } = this;
            this.setFetching(true);
            this.cancelInvoice({
                idinvoice: getInvoiceId,
                catatan: catatan,
                setujui: 1,
            })
                .then((res) => {
                    if (!res.data) {
                        this.$toast.error(res);
                    } else {
                        let { code, data, status, msg } = res.data;
                        if (code === 200 && status) {
                            this.$toast.success(msg);
                            this.setFetching(false);
                            if (this.isNotification) {
                  this.flutterNavigate("dashboard/notification");
                  return;
                            }
                            this.$router.go(-2);
                        } else {
                            this.$toast.error(msg);
                            this.setFetching(false);
                        }
                    }
                })
                .catch((e) => {
                    this.$toast.error(e);
                    this.setFetching(false);
                });
        },
        doConfirm() {
            let {
                posted: { akunKeuangan },
                isLunas,
            } = this;
            if (isLunas) {
                if (!akunKeuangan) {
                    this.$toast.warning("Mohon pilih Akun keuangan terlebih dahulu!");
                    return;
                }
                this.refundDana();
            } else {
                this.pembatalan();
            }
        },
    },
};
</script>
